import { ChangeEvent, ReactNode } from 'react'


export type ItemType = {
  id: string
  title: string
  leftShiftLevel?: number
  sortable?: number | string
  searchable?: string
  disabled?: boolean
} | {
  ID: string
  title: string
  leftShiftLevel?: number
  sortable?: number | string
  searchable?: string
  disabled?: boolean
}

export type ItemsDataType = {
  [key: string]: ItemType
} | Array<ItemType>

export const getID = (item: ItemType) => {
  if ('ID' in item) {
    return item.ID
  }
  return item.id
}

export type BeforeRenderModalItemFunction = <T extends ItemType>(
  jsx: ReactNode,
  item: T,
  props: {
    className: string,
    onChange: (e: ChangeEvent<HTMLInputElement>) => void,
    multiple: boolean,
    checked: boolean
  }
) => ReactNode
